export default "__VITE_ASSET__BwEP905k__"